export default class ContentSwitcher {
    static init(): void {
        // Funkce pro přepínání obsahu
        function initContentSwitcher(): void {
            // Najdeme všechny tlačítka pro přepínání
            const switchButtons = document.querySelectorAll<HTMLElement>('.person-order-switch__button');

            if (switchButtons.length === 0) {
                return;
            }

            // Přidáme event listener pro každé tlačítko
            switchButtons.forEach((button) => {
                button.addEventListener('click', function (this: HTMLElement, e: Event) {
                    e.preventDefault();

                    // Získáme ID obsahu, který se má zobrazit
                    const targetContentId = this.getAttribute('data-switch-button');

                    // Najdeme kontejner switcheru
                    const switchContainer = this.closest('.person-order-switch') as HTMLElement;

                    if (!switchContainer) return;

                    // Deaktivujeme všechna tlačítka v tomto kontejneru
                    const allButtons = switchContainer.querySelectorAll<HTMLElement>('.person-order-switch__button');
                    allButtons.forEach((btn) => btn.classList.remove('is-active'));

                    // Aktivujeme kliknuté tlačítko
                    this.classList.add('is-active');

                    // Skryjeme všechny obsahy v tomto kontejneru
                    const allContents = switchContainer.querySelectorAll<HTMLElement>('.person-order-switch__content');
                    allContents.forEach((content) => content.classList.remove('is-active'));

                    // Zobrazíme cílový obsah
                    if (targetContentId) {
                        const targetContent = switchContainer.querySelector<HTMLElement>(
                            `[data-switch-content="${targetContentId}"]`,
                        );
                        if (targetContent) {
                            targetContent.classList.add('is-active');
                        }
                    }
                });
            });
        }

        // Funkce pro inicializaci checkbox filtrů
        function initCheckboxFilters(): void {
            // Najdeme všechny checkboxy s třídou filter-checkbox__input
            const checkboxes = document.querySelectorAll<HTMLInputElement>('.filter-checkbox__input');

            checkboxes.forEach((checkbox) => {
                // Přidáme event listener pro každý checkbox
                checkbox.addEventListener('change', function (this: HTMLInputElement) {
                    // Získáme ID cílového elementu z data-area atributu
                    const targetId = this.getAttribute('data-area');

                    if (targetId) {
                        // Odstraníme # z začátku ID pokud je tam
                        const elementId = targetId.replace('#', '');
                        const targetElement = document.getElementById(elementId);

                        if (targetElement) {
                            if (this.checked) {
                                // Pokud je checkbox zaškrtnutý, odstraníme třídu "is-not-active"
                                targetElement.classList.remove('is-not-active');
                            } else {
                                // Pokud není checkbox zaškrtnutý, přidáme třídu "is-not-active"
                                targetElement.classList.add('is-not-active');
                            }
                        }
                    }
                });

                // Nastavíme počáteční stav při načtení stránky
                const targetId = checkbox.getAttribute('data-area');
                if (targetId) {
                    const elementId = targetId.replace('#', '');
                    const targetElement = document.getElementById(elementId);

                    if (targetElement) {
                        if (checkbox.checked) {
                            targetElement.classList.remove('is-not-active');
                        } else {
                            targetElement.classList.add('is-not-active');
                        }
                    }
                }
            });
        }

        // Spustíme obě funkce ihned
        initContentSwitcher();
        initCheckboxFilters();
    }
}
